const deJSON = {
  DUPLICATE_OF: 'Duplikat von',
  DUPLICATED_BY: 'Dupliziert von',
  RELATED_TO: 'Verwandt mit',
  SPLIT_TO: 'Aufgeteilt in',
  SPLIT_FROM: 'Aufgeteilt von',
  BLOCKED_BY: 'Blockiert von',
  BLOCKS: 'Blockiert',
  MORE_THAN: 'Größer als',
  LESS_THAN: 'Weniger als',
  OPEN: 'Offen',
  IN_PROGRESS: 'In Bearbeitung',
  ON_HOLD: 'In Wartestellung',
  COMPLETE: 'Abgeschlossen',
  'home.built': 'Entwickelt, um die Wartungsverwaltung zu erleichtern',
  home_description:
    'Wenn Whiteboards und Haftnotizen Chaos sind und Sie eine CMMS-Software benötigen, die einfach genug ist, damit Ihr Team sie tatsächlich nutzt - probieren Sie {{shortBrandName}}',
  try_grash: 'Probieren Sie {{shortBrandName}}',
  login: 'Einloggen',
  start_trial: 'Kostenlose Testversion starten',
  'home.what': 'Was',
  'home.you_will_have': 'Sie werden haben',
  'home.you_will_have_description':
    'Erstellen Sie effiziente, zuverlässige Workflows, die Ihnen die Kontrolle über die Wartung geben. Generieren, zuweisen und verfolgen Sie Arbeitsaufträge. Kontrollieren Sie Inventar. Und erhalten Sie zuverlässige automatisierte Berichte, die die Sichtbarkeit verbessern und Verantwortlichkeit schaffen.',
  key_features: 'Hauptfunktionen',
  key_features_description:
    'Einige der Funktionen, die {{shortBrandName}} zu einem der besten heute verfügbaren CMMS machen',
  contribute: 'Beitragen',
  work_orders: 'Arbeitsaufträge',
  request_system: 'Arbeitsanforderungssystem',
  mobile_app: 'Mobile App',
  asset_management: 'Anlagenverwaltung',
  preventive_maintenance: 'Präventive Wartung',
  parts_inventory: 'Teileinventar',
  custom_dashboards: 'Benutzerdefinierte Dashboards',
  'work-orders.title': 'Verwalten Sie Ihre Arbeitsaufträge wie ein Chef',
  'work-orders.description.short': 'Alle Ihre Aufgaben anzeigen und verwalten',
  'work-orders.descriptions.0':
    'Sind Sie es leid, Berge von Papierkram und verlorene Arbeitsaufträge zu haben? All diese verlorenen Gegenstände wirken sich direkt auf das Endergebnis und Ihren Ruf aus.',
  'work-orders.descriptions.1':
    'Mit {{shortBrandName}} können Sie alle Ihre Arbeitsaufträge, PMs und andere Aufgaben einfach und schnell in einem zentralen Datenbanksystem organisieren, das überall auf jedem Gerät zugänglich ist.',
  'work-orders.checks.0':
    'Alle Ihre Aufgaben anzeigen, einschließlich WOs, PMs und Arbeitsanforderungen',
  'work-orders.checks.1':
    'Aufgabenpriorität festlegen, damit die richtige Arbeit zuerst erledigt wird.',
  'work-orders.checks.2':
    'Einen Kalender der aktuellen und bevorstehenden Aufgaben anzeigen.',
  'work-orders.checks.3':
    'Arbeitszuweisungen mit kritischen Informationen wie Anlageninformationen, Fälligkeitsdatum, Priorität und mehr anzeigen.',
  'work-orders.checks.4':
    'Kritische KPIs anzeigen, wie tatsächlich abgeschlossene Arbeiten, aufgewendete Zeit und geplante vs. ungeplante Arbeiten.',
  'work-requests.title': 'Ein optimiertes mobiles Arbeitsanforderungssystem',
  'work-requests.descriptions.0':
    'Sind Sie es leid, das alte Telefon- und E-Mail-System zu verwenden, das zu VERLORENEN Tickets, ständigen täglichen Unterbrechungen und doppelter Arbeit führt?',
  'work-requests.descriptions.1':
    'Die Wartungsmanagementlösung von {{shortBrandName}} ermöglicht es jedem, den Sie autorisieren, ein Problem an Ihre Wartungsabteilung zu melden, indem er einfach einen QR-Code (Barcode) scannt oder eine URL besucht und seine Anfrage über seine mobilen Geräte eingibt.',
  'work-requests.checks.0': 'Niemals wieder Arbeit verlieren.',
  'work-requests.checks.1':
    'Zeit, die für die Bearbeitung von Arbeitsanforderungen aufgewendet wird, um bis zu 34 % reduzieren.',
  'work-requests.checks.2':
    'Zeit, die für die Kommunikation mit Anforderern aufgewendet wird, um bis zu 41 % reduzieren (Anrufe, E-Mails, SMS).',
  'mobile-app.title': 'Eine mobile CMMS-App, die Ihr Wartungsteam stärkt',
  'mobile-app.descriptions.0':
    'Durch die Nutzung unserer Android- und IOS-Apps erfahren unsere Kunden eine bessere Organisation, Kommunikation, Verantwortlichkeit und Produktivität um bis zu 30 % in ihrem gesamten Wartungsteam.',
  'mobile-app.descriptions.1':
    'Von ihrem Handgerät aus kann jeder in Ihrem Wartungsteam:',
  'mobile-app.checks.0': 'Ihre zugewiesenen Arbeitsaufträge und PMs anzeigen.',
  'mobile-app.checks.1':
    'Ihre Arbeitsaufträge in weniger als 60 Sekunden protokollieren',
  'mobile-app.checks.2':
    'Sofortige Kommunikation über Push- und E-Mail-Benachrichtigungen erhalten.',
  'mobile-app.checks.3':
    'Neue Arbeitsaufträge starten, während sie im Feld sind.',
  'mobile-app.checks.4':
    'Probleme bearbeiten und protokollieren, während sie tatsächlich an dem Problem arbeiten',
  'mobile-app.checks.5':
    'Kritische Anlageninformationen nachschlagen, während ein Problem diagnostiziert wird.',
  'eam.title': 'Enterprise Asset Management',
  'eam.description.short': 'Kennen Sie Ihre Anlagen',
  'eam.descriptions.0':
    'Frustriert, die chaotische Unordnung der Unternehmensausrüstung zu organisieren, sich zu fragen, ob die Ausrüstung richtig gepflegt wurde, nicht zu wissen, was sie kosten, um sie zu warten, und all die anderen Kopfschmerzen, die mit der Verwaltung von Anlagen einhergehen?',
  'eam.descriptions.1':
    'Das Enterprise Asset Management-Modul von {{brandName}} kann für 10 bis 1.000.000 Anlagen verwendet werden, sodass Sie genau das verfolgen können, was Sie möchten, auf die Weise, wie Sie es möchten, in einer benutzerfreundlichen und durchsuchbaren Baumstruktur.',
  'eam.checks.0':
    'Kennen Sie den Zustand Ihrer Anlagen jederzeit und was sie kosten',
  'eam.checks.1': 'Komplette und detaillierte Wartungsprotokolle anzeigen.',
  'eam.checks.2':
    'Verfolgen Sie nur das, was Sie möchten, mit unbegrenzten benutzerdefinierten Feldern',
  'eam.checks.3':
    'Organisieren Sie Ihre Anlagen in einer klaren Eltern-Kind-Hierarchie',
  'eam.checks.4':
    'Informationen schnell und einfach mit QR-Codes (Barcodes) finden',
  'eam.checks.5': 'Echtzeit-Anlagendaten mit Sensorverbindung erhalten.',
  'pm.title': 'Ein effektives präventives Wartungsprogramm',
  'pm.descriptions.0':
    'Hören Sie auf, wertvolle Stunden mit dem manuellen Verteilen von PM-Checklisten zu verschwenden und Ihrem Team nachzugehen, um sicherzustellen, dass die Arbeit erledigt wird.',
  'pm.descriptions.1':
    '{{shortBrandName}} ermöglicht es Ihnen, die PM-Planung einfach zu automatisieren, sodass die richtige Arbeit zur richtigen Zeit an den richtigen Techniker für das richtige Asset geliefert wird.',
  'pm.checks.0':
    'PM-Planung automatisieren, um täglich, wöchentlich, monatlich, jährlich oder basierend auf Ereignissen oder Zählerständen zu sein.',
  'pm.checks.1':
    'Automatische Push- und E-Mail-Benachrichtigungen, wenn ein PM erstellt oder fällig ist.',
  'pm.checks.2':
    'Unser benutzerfreundlicher Kalender ermöglicht es Ihnen, alle offenen Arbeiten und bevorstehenden PM-Zeitpläne anzuzeigen.',
  'pm.checks.3': 'Per Drag & Drop das Fälligkeitsdatum ändern.',
  'pm.checks.4':
    'Nach Abschluss des PM wird die Arbeit automatisch im Wartungsprotokoll des Assets protokolliert.',
  'pm.checks.5': 'Erfordert wenig bis keine Schulung zur Nutzung.',
  'part.title': 'Kontrollieren Sie Ihr Ersatzteillager',
  'part.description.short': 'Wissen Sie, wann Ihre Teile ausgehen',
  'part.descriptions.0':
    'Nicht sicher, welche Teile Sie auf Lager haben oder wo sie verwendet werden? Wissen Sie nicht, wann Ihre Teile ausgehen oder ob Ihre Techniker die notwendigen Teile haben, um ihre Aufgaben zu erledigen?',
  'part.descriptions.1':
    'Wir haben das Teilemanagement von {{shortBrandName}} entwickelt, um diese Probleme und mehr zu lösen:',
  'part.checks.0':
    'Erhalten Sie sofortige Push- und E-Mail-Benachrichtigungen, wenn die Menge eines Teils niedrig ist. Halten Sie die richtige Anzahl von Teilen auf Lager, indem Sie sofortige und automatische Push/E-Mail-Benachrichtigungen erhalten, wenn die Menge eines Teils unter einem benutzerdefinierten Schwellenwert liegt.',
  'part.checks.1':
    'Techniker wissen sofort, ob das Teil auf Lager ist, aus einem Arbeitsauftrag heraus. Wenn das Teil nicht auf Lager ist, überprüfen Sie einfach andere Standorte, um zu sehen, ob es verfügbar ist.',
  'part.checks.2':
    'Automatische Teileverfolgung. Wenn Arbeitsaufträge oder PMs Teile verwenden, wird das Inventar automatisch aktualisiert, um die verwendeten Teile widerzuspiegeln.',
  'part.checks.3':
    'Teilenutzung kennen. Sehen Sie sich das Teileprotokoll an, um zu sehen, wo das Teil verwendet wird und von wem',
  'part.checks.4':
    'Unbenutzte Teile eliminieren. Wissen Sie, wann ein Teil veraltet ist.',
  'part.checks.5':
    'Echtzeit-Berichterstattung. Wissen Sie, welche Teile wo verwendet werden und wie viel sie kosten.',
  'part.checks.6':
    'Bestandsniveaus optimieren. Sofortige Prognosen für ein Teil anzeigen, um zu sehen, wie viele Teile im nächsten Jahr verwendet werden könnten.',
  'part.checks.7':
    'Barcode-Suche. Machen Sie Ihr Inventar mit benutzerdefinierten QR-Codes einfach zu verfolgen und zuzugreifen.',
  'dashboard.title':
    'Ihre Daten, auf Ihre Weise mit benutzerdefinierten Dashboards',
  'dashboard.descriptions.0':
    'Lassen Sie uns ehrlich sein, der erste Schritt zur Verbesserung Ihrer Abläufe besteht darin, das Gute, das Schlechte und das Hässliche zu kennen.',
  'dashboard.descriptions.1':
    'Mit den benutzerdefinierten Dashboards von {{shortBrandName}} können Sie endlich beginnen, dieses berüchtigte „schwarze Loch der Wartung“ zu verstehen und datengestützte Pläne in die Tat umzusetzen, was zu reduzierten Arbeitskosten, verringerten Ausfallzeiten und mehr führt.',
  'dashboard.descriptions.2':
    'Mit den benutzerdefinierten Dashboards von {{shortBrandName}} erhalten Sie …',
  'dashboard.checks.0': 'Wissen Sie, wo Ihr Geld ausgegeben wird und warum',
  'dashboard.checks.1': 'Wissen Sie, welches Asset am meisten kostet und warum',
  'dashboard.checks.2': 'Erstellen Sie Ihre eigenen benutzerdefinierten KPIs.',
  'dashboard.checks.3':
    'Berichte anzeigen, die automatisch basierend auf Ihrer Metrik generiert und aktualisiert werden',
  'dashboard.checks.4':
    'Berichte anzeigen, die leicht über Excel-Tabellen, PDFs oder innerhalb von {{shortBrandName}} geteilt werden können',
  'dashboard.checks.5': 'Und vieles mehr ...',
  'home.smarter': 'Intelligenter',
  'home.work': 'Arbeit',
  'home.smarter_description':
    '{{shortBrandName}} macht es Technikern unglaublich einfach, effizient zu arbeiten, indem es ihnen Zugang zu den Werkzeugen und Daten gibt, die sie benötigen, um Arbeit zu erledigen – alles aus der Handfläche.',
  leading_maintenance:
    'Führung auf dem Weg zu einer besseren Zukunft für Wartung und Zuverlässigkeit',
  //register
  premium_included: 'Premium-Funktionen enthalten',
  no_credit_card: 'Keine Kreditkarte erforderlich',
  perfect_tool: 'Das perfekte Werkzeug für Wartungsteams',
  start_trial_today: 'Starten Sie heute Ihre kostenlose Testversion',
  create_account: 'Konto erstellen',
  signup_description:
    'Füllen Sie die untenstehenden Felder aus, um sich für ein Konto anzumelden.',
  account_already: 'Haben Sie bereits ein Konto?',
  signin_here: 'Hier anmelden',
  invalid_email:
    'Die angegebene E-Mail-Adresse sollte eine gültige E-Mail-Adresse sein',
  required_email: 'Das E-Mail-Feld ist erforderlich',
  required_firstName: 'Das Feld für den Vornamen ist erforderlich',
  required_lastName: 'Das Feld für den Nachnamen ist erforderlich',
  required_company: 'Das Feld für den Firmennamen ist erforderlich',
  required_employeesCount: 'Bitte geben Sie die Anzahl der Mitarbeiter an',
  invalid_phone: 'Die Telefonnummer ist ungültig',
  required_password: 'Das Passwortfeld ist erforderlich',
  required_terms:
    'Sie müssen unseren Allgemeinen Geschäftsbedingungen zustimmen',
  verify_email: 'Bitte überprüfen Sie Ihre E-Mails, um Ihr Konto zu aktivieren',
  registration_error: 'Die Registrierung war nicht erfolgreich',
  first_name: 'Vorname',
  last_name: 'Nachname',
  email: 'E-Mail-Adresse',
  phone: 'Telefon',
  password: 'Passwort',
  companyName: 'Firmenname',
  employeesCount: 'Anzahl der Mitarbeiter',
  i_accept: 'Ich akzeptiere die',
  terms_conditions: 'Allgemeinen Geschäftsbedingungen',
  create_your_account: 'Erstellen Sie Ihr Konto',
  register: 'Registrieren',
  //signin
  login_description:
    'Füllen Sie die untenstehenden Felder aus, um sich in Ihr Konto einzuloggen.',
  no_account_yet: 'Noch kein Konto?',
  signup_here: 'Hier registrieren',
  wrong_credentials: 'Falsche Anmeldedaten angegeben',
  lost_password: 'Passwort vergessen?',
  //work-orders
  link_wo: 'Arbeitsaufträge verknüpfen',
  link_wo_description: 'Beziehungen zwischen Arbeitsaufträgen erstellen',
  required_relationType: 'Bitte wählen Sie den Beziehungstyp aus.',
  required_wo: 'Das Arbeitsauftragsfeld ist erforderlich.',
  this_wo: 'Dieser Arbeitsauftrag',
  the_wo: 'Der Arbeitsauftrag',
  link: 'Verknüpfen',
  cost_description: 'Kostenbeschreibung',
  assigned_to: 'Zugewiesen an',
  category: 'Kategorie',
  date: 'Datum',
  cost: 'Kosten',
  include_cost: 'Diese Kosten in die Gesamtkosten einbeziehen',
  include_cost_description:
    'Dies fügt die Kosten zu den Gesamtkosten hinzu, die für den Arbeitsauftrag ausgegeben wurden',
  required_cost_description: 'Kostenbeschreibung ist erforderlich',
  required_cost: 'Kosten sind erforderlich',
  add_cost: 'Zusätzliche Kosten hinzufügen',
  add_cost_description:
    'Füllen Sie die untenstehenden Felder aus, um zusätzliche Kosten zu erstellen und hinzuzufügen',
  add: 'Hinzufügen',
  hourly_rate: 'Stundensatz',
  include_time: 'Diese Zeit in die Gesamtzeit einbeziehen',
  include_time_description:
    'Dies fügt die Dauer zur insgesamt für den Arbeitsauftrag aufgewendeten Zeit hinzu',
  work_started_at: 'Arbeit begonnen um',
  duration: 'Dauer',
  hours: 'Stunden',
  minutes: 'Minuten',
  required_hours: 'Stundenfeld ist erforderlich',
  required_minutes: 'Minutenfeld ist erforderlich',
  add_time: 'Zeit hinzufügen',
  add_time_description:
    'Füllen Sie die untenstehenden Felder aus, um Zeit zu erstellen und hinzuzufügen',
  feedback: 'Feedback',
  feedback_description: 'Geben Sie Ihr Feedback',
  required_feedback: 'Feedback ist erforderlich',
  signature: 'Unterschrift',
  required_signature: 'Bild ist erforderlich',
  close_wo: 'Arbeitsauftrag schließen',
  close: 'Schließen',
  task_update_success: 'Aufgabe erfolgreich aktualisiert',
  task_update_failure: 'Aufgabe konnte nicht aktualisiert werden',
  notes_save_success: 'Notizen erfolgreich gespeichert',
  images_add_task_success: 'Die Bilder wurden zur Aufgabe hinzugefügt',
  images_add_task_failure: 'Etwas ist schief gelaufen',
  images: 'Bilder',
  required_images: 'Bitte laden Sie mindestens ein Bild hoch',
  add_images: 'Bilder hinzufügen',
  tasks: 'Aufgaben',
  wo_archive_success: 'Der Arbeitsauftrag wurde archiviert',
  wo_archive_failure: 'Der Arbeitsauftrag konnte nicht archiviert werden',
  wo_archive_confirm:
    'Sind Sie sicher, dass Sie diesen Arbeitsauftrag archivieren möchten?',
  quantity_change_success: 'Menge erfolgreich geändert',
  quantity_change_failure: 'Menge konnte nicht geändert werden',
  details: 'Details',
  updates: 'Aktualisierungen',
  id: 'ID',
  due_date: 'Fälligkeitsdatum',
  location: 'Standort',
  asset: 'Anlage',
  team: 'Team',
  created_at: 'Erstellt am',
  list_view: 'Listenansicht',
  calendar_view: 'Kalenderansicht',
  column_view: 'Spaltenansicht',
  wo_create_success: 'Der Arbeitsauftrag wurde erfolgreich erstellt',
  wo_create_failure: 'Der Arbeitsauftrag konnte nicht erstellt werden',
  changes_saved_success: 'Die Änderungen wurden gespeichert',
  wo_update_failure: 'Der Arbeitsauftrag konnte nicht bearbeitet werden',
  wo_delete_success: 'Der Arbeitsauftrag wurde erfolgreich gelöscht',
  wo_delete_failure: 'Der Arbeitsauftrag konnte nicht gelöscht werden',
  status: 'Status',
  title: 'Titel',
  priority: 'Priorität',
  description: 'Beschreibung',
  worker: 'Arbeiter',
  location_name: 'Standortname',
  location_address: 'Standortadresse',
  asset_name: 'Anlagenname',
  days_since_creation: 'Tage seit Erstellung',
  files: 'Dateien',
  requested_by: 'Angefordert von',
  completed_on: 'Abgeschlossen am',
  updated_at: 'Aktualisiert am',
  work_order: 'Arbeitsauftrag',
  timer_running: 'Timer läuft',
  run_timer: 'Timer starten',
  approved_by: 'Genehmigt von',
  created_by: 'Erstellt von',
  completed_by: 'Abgeschlossen von',
  time: 'Zeit',
  save: 'Speichern',
  customers: 'Auftragnehmer',
  no_labor:
    'Es wurden noch keine Arbeitskosten hinzugefügt. Sie werden hier angezeigt, wenn ein Benutzer Zeit protokolliert und ein Stundensatz in {{shortBrandName}} gespeichert ist.',
  not_assigned: 'Nicht zugewiesen',
  no_additional_cost: 'Es wurden noch keine zusätzlichen Kosten hinzugefügt',
  parts: 'Teile',
  links: 'Links',
  confirm_delete_file_wo:
    'Sind Sie sicher, dass Sie diese Datei aus diesem Arbeitsauftrag entfernen möchten?',
  archive: 'Archiv',
  labors: 'Arbeiten',
  add_additional_cost: 'Zusätzliche Kosten hinzufügen',
  additional_costs: 'Zusätzliche Kosten',
  add_parts: 'Teile hinzufügen',
  'wo.title_description': 'Geben Sie den Titel des Arbeitsauftrags ein',
  image: 'Bild',
  estimated_duration: 'Geschätzte Dauer in Stunden',
  primary_worker: 'Hauptarbeiter',
  additional_workers: 'Zusätzliche Arbeiter',
  select_team: 'Team auswählen',
  select_location: 'Standort auswählen',
  select_asset: 'Anlage auswählen',
  select_tasks: 'Aufgaben auswählen',
  requires_signature: 'Erfordert Unterschrift',
  required_wo_title: 'Arbeitsauftrags-Titel ist erforderlich',
  add_wo: 'Arbeitsauftrag hinzufügen',
  add_wo_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Arbeitsauftrag zu erstellen und hinzuzufügen',
  edit_wo: 'Arbeitsauftrag bearbeiten',
  edit_wo_description:
    'Füllen Sie die untenstehenden Felder aus, um den Arbeitsauftrag zu aktualisieren',
  'noRows.wo.message':
    'Arbeitsaufträge sind Aufgaben oder Jobs, die geplant oder jemandem zugewiesen werden können',
  'noRows.wo.action':
    'Drücken Sie die "+"-Taste, um einen Arbeitsauftrag zu erstellen',
  to_delete: 'Löschen',
  confirm_delete_wo:
    'Sind Sie sicher, dass Sie diesen Arbeitsauftrag löschen möchten?',
  no_access_wo:
    'Sie haben keinen Zugriff auf Arbeitsaufträge. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  cancel: 'Abbrechen',
  select_parts: 'Teile auswählen',
  sets_of_parts: 'Teilesätze',
  //preventive maintenance
  paused: 'Pausiert',
  trigger_details: 'Trigger-Details',
  starts_on: 'Beginnt am',
  ends_on: 'Endet am',
  frequency: 'Frequenz',
  every_frequency_days: 'Alle {{frequency}} Tage',
  wo_details: 'Details des Arbeitsauftrags',
  confirm_delete_file:
    'Sind Sie sicher, dass Sie diese Datei entfernen möchten?',
  wo_schedule_success: 'Arbeitsauftrag erfolgreich geplant',
  wo_schedule_failure: 'Der Arbeitsauftrag konnte nicht geplant werden',
  wo_trigger_edit_failure:
    'Der Arbeitsauftrag-Trigger konnte nicht bearbeitet werden',
  wo_trigger_delete_success:
    'Der Arbeitsauftrag-Trigger wurde erfolgreich gelöscht',
  wo_trigger_delete_failure:
    'Der Arbeitsauftrag-Trigger konnte nicht gelöscht werden',
  name: 'Name',
  wo_title: 'Titel des Arbeitsauftrags',
  next_wo: 'Nächster Arbeitsauftrag',
  trigger_name: 'Trigger-Name',
  enter_trigger_name: 'Geben Sie den Trigger-Namen ein',
  frequency_description: 'Frequenz in Tagen',
  wo_configuration: 'Konfiguration des Arbeitsauftrags',
  required_trigger_name: 'Trigger-Name ist erforderlich',
  required_frequency: 'Die Trigger-Frequenz ist erforderlich',
  invalid_frequency: 'Frequenz muss größer als 0 sein',
  schedule_wo: 'Arbeitsauftrag planen',
  schedule_wo_description:
    'Füllen Sie die untenstehenden Felder aus, um einen Arbeitsauftrag zu planen',
  edit_wo_trigger: 'Arbeitsauftrag-Trigger bearbeiten',
  edit_wo_trigger_description:
    'Füllen Sie die untenstehenden Felder aus, um den Arbeitsauftrag-Trigger zu bearbeiten',
  create_trigger: 'Trigger erstellen',
  'noRows.pm.message':
    'Planen Sie Arbeitsaufträge mit benutzerdefinierten Triggern',
  'noRows.pm.action':
    'Drücken Sie die "+"-Taste, um einen Trigger zu erstellen',
  confirm_delete_pm:
    'Sind Sie sicher, dass Sie diesen Arbeitsauftrag-Trigger löschen möchten?',
  no_access_pm:
    'Sie haben keinen Zugriff auf den Bereich Präventive Wartung. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  enter_wo_title: 'Geben Sie den Titel des Arbeitsauftrags ein',
  //menuItems
  status_report: 'Statusbericht',
  wo_analysis: 'Analyse der Arbeitsaufträge',
  wo_aging: 'Alterung der Arbeitsaufträge',
  time_and_cost: 'Zeit und Kosten',
  assets: 'Anlagen',
  reliability_dashboard: 'Zuverlässigkeits-Dashboard',
  total_maintenance_cost: 'Gesamtkosten der Wartung',
  useful_life: 'Nutzungsdauer',
  requests: 'Anfragen',
  locations: 'Standorte',
  parts_and_inventory: 'Teile/Inventar',
  purchase_orders: 'Bestellungen',
  meters: 'Zähler',
  people_teams: 'Personen & Teams',
  people: 'Personen',
  teams: 'Teams',
  vendors_customers: 'Lieferanten & Auftragnehmer',
  vendors: 'Lieferanten',
  categories: 'Kategorien',
  settings: 'Einstellungen',
  //request
  cancelled: 'Abgesagt',
  reject: 'Ablehnen',
  approve: 'Genehmigen',
  request_create_success: 'Arbeitsauftrag erfolgreich angefordert',
  request_create_failure: 'Die Arbeitsanforderung konnte nicht erstellt werden',
  request_edit_failure: 'Die Anfrage konnte nicht bearbeitet werden',
  request_delete_success: 'Die Anfrage wurde erfolgreich gelöscht',
  request_delete_failure: 'Die Anfrage konnte nicht gelöscht werden',
  rejected: 'Abgelehnt',
  approved: 'Genehmigt',
  pending: 'Ausstehend',
  required_request_name: 'Anfragetitel ist erforderlich',
  required_field: 'Dieses Feld ist erforderlich',
  add_request: 'Anfrage hinzufügen',
  add_request_description:
    'Füllen Sie die untenstehenden Felder aus, um eine neue Anfrage zu erstellen und hinzuzufügen',
  edit_request: 'Anfrage bearbeiten',
  edit_request_description:
    'Füllen Sie die untenstehenden Felder aus, um die Anfrage zu bearbeiten',
  'noRows.request.message': 'Verwalten Sie Ihre Arbeitsanforderungen',
  'noRows.request.action':
    'Drücken Sie die "+"-Taste, um eine Arbeitsanforderung zu erstellen',
  confirm_delete_request:
    'Sind Sie sicher, dass Sie diese Anfrage löschen möchten?',
  request: 'Anfrage',
  request_details: 'Anfragedetails',
  none_priority: 'Keine',
  low_priority: 'Niedrig',
  medium_priority: 'Mittel',
  high_priority: 'Hoch',
  //asset
  downtimes: 'Ausfallzeiten',
  confirm_delete_file_asset:
    'Sind Sie sicher, dass Sie diese Datei von dieser Anlage entfernen möchten?',
  actions: 'Aktionen',
  show: 'Anzeigen',
  model: 'Modell',
  serial_number: 'Seriennummer',
  operational: 'Betriebsbereit',
  down: 'Aus',
  area: 'Bereich',
  barcode: 'Barcode',
  placed_in_service: 'In Dienst gestellt',
  warranty_expiration: 'Garantieablauf',
  asset_information: 'Anlageninformationen',
  more_informations: 'Weitere Informationen',
  confirm_delete_asset_downtime:
    'Sind Sie sicher, dass Sie diese Ausfallzeit entfernen möchten?',
  create_downtime_success: 'Die Ausfallzeit wurde erfolgreich hinzugefügt',
  create_downtime_failure: 'Die Ausfallzeit konnte nicht hinzugefügt werden',
  edit_downtime_success: 'Die Ausfallzeit wurde erfolgreich bearbeitet',
  started_on: 'Begonnen am',
  required_startsOn: 'Das Startdatum ist erforderlich',
  reading_create_success: 'Die Messung wurde erfolgreich hinzugefügt',
  reading_create_failure: 'Die Messung konnte nicht hinzugefügt werden',
  reading: 'Messung',
  added_by: 'Hinzugefügt von',
  enter_meter_value: 'Zählerwert eingeben',
  add_reading: 'Messung hinzufügen',
  select_meter: 'Zähler auswählen',
  confirm_delete_part_asset:
    'Sind Sie sicher, dass Sie dieses Teil von dieser Anlage entfernen möchten?',
  no_due_date: 'Kein Fälligkeitsdatum',
  due_at_date: 'Fällig am {{date}}',
  no_primary_worker: 'Kein Hauptarbeiter',
  no_wo_linked_asset: 'Es ist kein Arbeitsauftrag mit dieser Anlage verknüpft',
  asset_remove_success: 'Die Anlage wurde erfolgreich gelöscht',
  asset_remove_failure: 'Die Anlage konnte nicht gelöscht werden',
  asset_name_description: 'Anlagennamen eingeben',
  select_asset_location: 'Anlagenstandort auswählen',
  primary_user_description: 'Hauptbenutzer auswählen',
  teams_description: 'Teams auswählen',
  customers_description: 'Auftragnehmer auswählen',
  vendors_description: 'Lieferanten auswählen',
  inServiceDate_description: 'In Dienst gestelltes Datum',
  warranty_expiration_date: 'Garantieablaufdatum',
  additional_information: 'Zusätzliche Informationen',
  structure: 'Struktur',
  parent_asset: 'Übergeordnete Anlage',
  asset_create_success: 'Die Anlage wurde erfolgreich erstellt',
  asset_create_failure: 'Die Anlage konnte nicht erstellt werden',
  additional_workers_description: 'Zusätzliche Arbeiter auswählen',
  required_asset_name: 'Anlagenname ist erforderlich',
  add_asset: 'Anlage hinzufügen',
  add_asset_description:
    'Füllen Sie die untenstehenden Felder aus, um eine neue Anlage zu erstellen und hinzuzufügen',
  create_asset: 'Anlage erstellen',
  hierarchy: 'Hierarchie',
  add_downtime: 'Ausfallzeit hinzufügen',
  edit_downtime: 'Ausfallzeit bearbeiten',
  remove_downtime: 'Ausfallzeit entfernen',
  edit: 'Bearbeiten',
  edit_asset: 'Anlage bearbeiten',
  edit_asset_description:
    'Füllen Sie die untenstehenden Felder aus, um diese Anlage zu bearbeiten',
  confirm_delete_asset:
    'Sind Sie sicher, dass Sie diese Anlage löschen möchten?',
  loading_assets: 'Lade Anlagen unter {{name}} #{{id}}',
  no_content: 'Kein Inhalt',
  no_result_criteria: 'Kein Ergebnis entspricht Ihren Suchkriterien',
  //location
  map_view: 'Kartenansicht',
  location_create_success: 'Der Standort wurde erfolgreich erstellt',
  location_create_failure: 'Der Standort konnte nicht erstellt werden',
  location_edit_failure: 'Der Standort konnte nicht bearbeitet werden',
  location_delete_success: 'Der Standort wurde erfolgreich gelöscht',
  location_delete_failure: 'Der Standort konnte nicht gelöscht werden',
  enter_location_name: 'Standortnamen eingeben',
  address: 'Adresse',
  parent_location: 'Übergeordneter Standort',
  select_workers: 'Arbeiter auswählen',
  map_coordinates: 'Koordinaten der Karte',
  required_location_name: 'Standortname ist erforderlich',
  required_location_address: 'Standortadresse ist erforderlich',
  add_location: 'Standort hinzufügen',
  add_location_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Standort zu erstellen und hinzuzufügen',
  edit_location: 'Standort bearbeiten',
  edit_location_description:
    'Füllen Sie die untenstehenden Felder aus, um den Standort zu aktualisieren',
  confirm_delete_location:
    'Sind Sie sicher, dass Sie diesen Standort löschen möchten?',
  floor_plans: 'Grundrisse',
  floor_plan: 'Grundriss',
  floor_plan_name_description: 'Grundrissname',
  'Floor plan area in m²': 'Grundrissfläche in m²',
  upload_image: 'Bild hochladen',
  required_floor_plan_name: 'Grundrissname ist erforderlich',
  add_floor_plan: 'Neuen Grundriss hinzufügen',
  add_floor_plan_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Grundriss zu erstellen',
  no_asset_in_location: 'Keine Anlage an diesem Standort',
  no_wo_in_location: 'Kein Arbeitsauftrag an diesem Standort',
  no_file_in_location: 'Keine Dateien an diesem Standort angehängt',
  no_floor_plan_in_location: 'Kein Grundriss an diesem Standort',
  assigned_teams: 'Zugewiesene Teams',
  assigned_customers: 'Zugewiesene Auftragnehmer',
  assigned_vendors: 'Zugewiesene Lieferanten',
  //no_access
  no_access_location:
    'Sie haben keinen Zugriff auf Standorte. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_vendors_customers:
    'Sie haben keinen Zugriff auf Lieferanten und Auftragnehmer. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_people_team:
    'Sie haben keinen Zugriff auf Personen und Teams. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_analytics:
    'Sie haben keinen Zugriff auf Analysen. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_assets:
    'Sie haben keinen Zugriff auf Anlagen. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_categories:
    'Sie haben keinen Zugriff auf Kategorien. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_files:
    'Sie haben keinen Zugriff auf Dateien. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_inventory:
    'Sie haben keinen Zugriff auf das Inventar. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_meters:
    'Sie haben keinen Zugriff auf Zähler. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_purchase_orders:
    'Sie können keine Bestellung erstellen. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_requests:
    'Sie haben keinen Zugriff auf Anfragen. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_settings:
    'Sie haben keinen Zugriff auf Einstellungen. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugriff haben sollten',
  no_access_page: 'Sie haben keinen Zugriff auf diese Seite',
  file: 'Datei',
  'noRows.location.message':
    'Standorte ermöglichen es Ihnen, Anlagen und Arbeiter effizienter zu verwalten',
  'noRows.location.action':
    'Drücken Sie die "+"-Taste, um einen Standort zu erstellen',
  //inventory
  card_view: 'Kartenansicht',
  set_create_success: 'Das Set wurde erfolgreich erstellt',
  set_create_failure: 'Das Set konnte nicht erstellt werden',
  set_edit_failure: 'Das Set konnte nicht bearbeitet werden',
  set_delete_success: 'Das Set wurde erfolgreich gelöscht',
  set_delete_failure: 'Das Set konnte nicht gelöscht werden',
  total_cost: 'Gesamtkosten',
  part: 'Teil',
  enter_part_name: 'Teilenamen eingeben',
  required_set_name: 'Set-Name ist erforderlich',
  add_set: 'Set hinzufügen',
  add_set_description:
    'Füllen Sie die untenstehenden Felder aus, um ein neues Set zu erstellen und hinzuzufügen',
  create_set: 'Set erstellen',
  edit_set: 'Set bearbeiten',
  edit_set_description:
    'Füllen Sie die untenstehenden Felder aus, um das Set zu bearbeiten',
  confirm_delete_set: 'Sind Sie sicher, dass Sie dieses Set löschen möchten?',
  part_create_success: 'Das Teil wurde erfolgreich erstellt',
  part_create_failure: 'Das Teil konnte nicht erstellt werden',
  part_edit_failure: 'Das Teil konnte nicht bearbeitet werden',
  part_delete_success: 'Das Teil wurde erfolgreich gelöscht',
  part_delete_failure: 'Das Teil konnte nicht gelöscht werden',
  quantity: 'Menge',
  open_wo: 'Offene Arbeitsaufträge',
  enter_part_category: 'Teilkategorie eingeben',
  enter_part_cost: 'Teilekosten eingeben',
  enter_part_quantity: 'Teilemenge eingeben',
  minimum_quantity: 'Mindestmenge',
  enter_part_minimum_quantity: 'Mindestmenge des Teils eingeben',
  non_stock: 'Nicht vorrätig',
  enter_part_barcode: 'Teile-Barcode eingeben',
  enter_part_area: 'Teilebereich eingeben',
  additional_part_details: 'Zusätzliche Teileinformationen',
  add_part: 'Teil hinzufügen',
  add_part_description:
    'Füllen Sie die untenstehenden Felder aus, um ein neues Teil zu erstellen und hinzuzufügen',
  create_part: 'Teil erstellen',
  update_part: 'Teil aktualisieren',
  update_part_description:
    'Füllen Sie die untenstehenden Felder aus, um das Teil zu aktualisieren',
  'noRows.part.message':
    'Teile können in Anlagen kombiniert oder einzeln verwendet werden',
  'noRows.part.action': 'Drücken Sie die "+"-Taste, um ein Teil zu erstellen',
  confirm_delete_part: 'Sind Sie sicher, dass Sie dieses Teil löschen möchten?',
  part_details: 'Teiledetails',
  area_details: 'Bereichsdetails',
  assigned_people: 'Zugewiesene Personen',
  no_asset_related_part: 'Keine Anlage im Zusammenhang mit diesem Teil',
  no_file_found: 'Keine Datei gefunden',
  no_wo_found: 'Kein Arbeitsauftrag gefunden',
  workers: 'Arbeiter',
  Parts_and_Inventory: 'Teile & Inventar',
  //purchase order
  po_edit_failure: 'Die Bestellung konnte nicht bearbeitet werden',
  po_delete_success: 'Die Bestellung wurde erfolgreich gelöscht',
  po_delete_failure: 'Die Bestellung konnte nicht gelöscht werden',
  number_of_items: 'Anzahl der Artikel',
  total_quantity: 'Gesamtmenge',
  shipping_to: 'Versand an',
  shipping_address: 'Versandadresse',
  po_details: 'Bestelldetails',
  enter_po_name: 'Bestellnamen eingeben',
  additional_details: 'Zusätzliche Details',
  vendor: 'Lieferant',
  shipping_information: 'Versandinformationen',
  company_name: 'Firmenname',
  ship_to: 'Versenden an',
  city: 'Stadt',
  state: 'Bundesland',
  zip_code: 'Postleitzahl',
  fax_number: 'Faxnummer',
  po_date: 'Bestelldatum',
  notes: 'Notizen',
  add_notes: 'Notizen hinzufügen',
  requisitioner: 'Anforderer',
  terms: 'Bedingungen',
  shipping_method: 'Versandart',
  required_name: 'Der Name ist erforderlich',
  edit_po: 'Bestellung bearbeiten',
  edit_po_description:
    'Füllen Sie die untenstehenden Felder aus, um die Bestellung zu aktualisieren',
  purchase_order: 'Bestellung',
  'noRows.po.message': 'Verwalten Sie Ihre Bestellungen an einem Ort',
  'noRows.po.action':
    'Drücken Sie die "+"-Taste, um eine Bestellung zu erstellen.',
  confirm_delete_po:
    'Sind Sie sicher, dass Sie diese Bestellung löschen möchten?',
  upgrade_po: 'Upgrade, um Bestellungen zu erstellen',
  new_po: 'Neue Bestellung',
  po_create_success: 'Die Bestellung wurde erfolgreich erstellt',
  select_one_part: 'Wählen Sie mindestens 1 Teil aus',
  po_create_failure: 'Die Bestellung konnte nicht erstellt werden',
  approve_while_submitting: 'Beim Einreichen genehmigen',
  invalid_fax: 'Die Faxnummer ist ungültig',
  submit: 'Einreichen',
  each_item_superior_zero: 'Die Menge jedes Artikels muss größer als 0 sein',
  quantity_edit_success: 'Menge erfolgreich geändert',
  quantity_edit_failure: 'Menge konnte nicht geändert werden',
  APPROVED: 'Genehmigt',
  PENDING: 'Ausstehend',
  REJECTED: 'Abgelehnt',
  //meter
  when_reading_is: 'Wenn Zählerstand ist',
  greater_than: 'Größer als',
  lower_than: 'Kleiner als',
  value: 'Wert',
  required_value: 'Der Wert ist erforderlich',
  required_trigger_condition: 'Die Bedingung ist erforderlich',
  wo_trigger_create_success:
    'Der Arbeitsauftrag-Trigger wurde erfolgreich erstellt',
  wo_trigger_create_failure:
    'Der Arbeitsauftrag-Trigger konnte nicht erstellt werden',
  add_wo_trigger: 'Arbeitsauftrag-Trigger hinzufügen',
  add_wo_trigger_description:
    'Füllen Sie die untenstehenden Felder aus, um einen Arbeitsauftrag-Trigger zu erstellen und hinzuzufügen',
  wo_trigger_edit_success:
    'Der Arbeitsauftrag-Trigger wurde erfolgreich aktualisiert',
  meter_create_success: 'Der Zähler wurde erfolgreich erstellt',
  meter_create_failure: 'Der Zähler konnte nicht erstellt werden',
  meter_edit_failure: 'Der Zähler konnte nicht bearbeitet werden',
  meter_delete_success: 'Der Zähler wurde erfolgreich gelöscht',
  meter_delete_failure: 'Der Zähler konnte nicht gelöscht werden',
  next_reading_due: 'Nächste Messung fällig',
  unit_of_measurement: 'Maßeinheit',
  last_reading: 'Letzte Messung',
  enter_meter_name: 'Zählername eingeben',
  unit: 'Einheit',
  update_frequency: 'Aktualisierungsfrequenz',
  update_frequency_in_days: 'Aktualisierungsfrequenz in Tagen',
  required_meter_name: 'Zählername ist erforderlich',
  required_meter_unit: 'Zähleinheit ist erforderlich',
  required_meter_update_frequency:
    'Zähleraktualisierungsfrequenz ist erforderlich',
  required_asset: 'Anlage ist erforderlich',
  add_meter: 'Zähler hinzufügen',
  add_meter_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Zähler zu erstellen und hinzuzufügen',
  edit_meter: 'Zähler bearbeiten',
  edit_meter_description:
    'Füllen Sie die untenstehenden Felder aus, um den Zähler zu bearbeiten',
  confirm_delete_meter:
    'Sind Sie sicher, dass Sie diesen Zähler löschen möchten?',
  upgrade_create_meter: 'Upgrade, um Zähler zu erstellen',
  history: 'Verlauf',
  reading_frequency: 'Messfrequenz',
  required_reading_value: 'Messwert ist erforderlich',
  wo_triggers: 'Arbeitsauftrag-Trigger',
  add_trigger: 'Trigger hinzufügen',
  meter_details: 'Zählerdetails',
  'noRows.meter.message':
    'Zählerstände ermöglichen es Ihnen, Anlagen zu überwachen und neue Arbeitsaufträge basierend auf definierten Bedingungen auszulösen',
  'noRows.meter.action':
    'Drücken Sie die "+"-Taste, um einen Zähler zu erstellen',
  meter: 'Zähler',
  //upload
  drag_one_file: 'Ziehen Sie eine einzelne Datei hierher',
  drag_many_files: 'Dateien hierher ziehen & ablegen',
  drop_to_start: 'Lassen Sie die Dateien fallen, um den Upload zu starten',
  invalid_files_type: 'Sie können diese Dateitypen nicht hochladen',
  you_have_uploaded: 'Sie haben hochgeladen',
  upload: 'Hochladen',
  //vendors_customers
  Vendors_Customers: 'Lieferanten & Auftragnehmer',
  customer_create_success: 'Der Auftragnehmer wurde erfolgreich erstellt',
  customer_create_failure: 'Der Auftragnehmer konnte nicht erstellt werden',
  customer_edit_failure: 'Der Auftragnehmer konnte nicht bearbeitet werden',
  customer_delete_success: 'Der Auftragnehmer wurde erfolgreich gelöscht',
  customer_delete_failure: 'Der Auftragnehmer konnte nicht gelöscht werden',
  customer_name: 'Auftragnehmername',
  website: 'Webseite',
  customer_type: 'Auftragnehmertyp',
  customer_type_description: 'z.B. Sanitär, Elektrik',
  customer_description_description:
    'Beschreiben Sie den Zweck dieses Auftragnehmers in ein paar Zeilen...',
  billing_information: 'Rechnungsinformationen',
  address_line_2: 'Adresszeile 2',
  billing_name: 'Rechnungsname',
  currency: 'Währung',
  select_currency: 'Währung auswählen',
  required_customer_name: 'Auftragnehmername ist erforderlich',
  required_phone: 'Die Telefonnummer ist erforderlich',
  invalid_website: 'Ungültige Webseite',
  billing_address: 'Rechnungsadresse',
  add_customer: 'Auftragnehmer hinzufügen',
  add_customer_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Auftragnehmer zu erstellen und hinzuzufügen',
  'noRows.customer.message': 'Auftragnehmer sind externe Arbeiter',
  'noRows.customer.action':
    'Drücken Sie die "+"-Taste, um einen Auftragnehmer zu erstellen',
  type: 'Typ',
  billing_currency: 'Rechnungswährung',
  go_back: 'Zurückgehen',
  confirm_delete_customer:
    'Sind Sie sicher, dass Sie diesen Auftragnehmer löschen möchten?',
  //vendor
  vendor_create_success: 'Der Lieferant wurde erfolgreich erstellt',
  vendor_create_failure: 'Der Lieferant konnte nicht erstellt werden',
  vendor_edit_failure: 'Der Lieferant konnte nicht bearbeitet werden',
  vendor_delete_success: 'Der Lieferant wurde erfolgreich gelöscht',
  vendor_delete_failure: 'Der Lieferant konnte nicht gelöscht werden',
  required_company_name: 'Firmenname ist erforderlich',
  vendor_type: 'Lieferantentyp',
  contact_name: 'Kontaktname',
  add_vendor: 'Lieferant hinzufügen',
  add_vendor_description:
    'Füllen Sie die untenstehenden Felder aus, um einen neuen Lieferanten zu erstellen und hinzuzufügen',
  confirm_delete_vendor:
    'Sind Sie sicher, dass Sie diesen Lieferanten löschen möchten?',
  'noRows.vendor.message':
    'Lieferanten sind Organisationen, die Anlagen oder Teile bereitstellen',
  'noRows.vendor.action':
    'Drücken Sie die "+"-Taste, um einen Lieferanten zu erstellen',
  vendor_type_description: 'z.B. Sanitär, Elektrik',
  //people teams
  role: 'Rolle',
  edit_user: 'Benutzer bearbeiten',
  edit_user_description:
    'Füllen Sie die untenstehenden Felder aus, um den Benutzer zu bearbeiten',
  job_title: 'Berufsbezeichnung',
  invite_users: 'Benutzer einladen',
  bring_people_team: 'Bringen Sie neue Personen ins Team',
  add_20_users:
    'Sie können 20 Benutzer gleichzeitig hinzufügen, indem Sie "Tab" oder "Enter" nach jeder E-Mail-Eingabe drücken. Alle doppelten und registrierten E-Mails werden beim Registrieren der angeforderten Benutzer entfernt.',
  enter_email: 'E-Mail-Adresse eingeben',
  users_invite_success: 'Benutzer wurden eingeladen',
  users_invite_failure:
    'Benutzer können nicht eingeladen werden. Überprüfen Sie die aktuelle Anzahl der Abonnementmitglieder',
  please_type_emails: 'Bitte geben Sie E-Mails ein, um einzuladen',
  please_select_role: 'Bitte wählen Sie eine Rolle aus',
  invite: 'Einladen',
  team_create_success: 'Das Team wurde erfolgreich erstellt',
  team_create_failure: 'Das Team konnte nicht erstellt werden',
  team_edit_failure: 'Das Team konnte nicht bearbeitet werden',
  team_delete_success: 'Das Team wurde erfolgreich gelöscht',
  team_delete_failure: 'Das Team konnte nicht gelöscht werden',
  team_name: 'Teamname',
  people_in_team: 'Personen im Team',
  required_team_name: 'Teamname ist erforderlich',
  create_team: 'Team erstellen',
  create_team_description: 'Sie können hier Teammitglieder hinzufügen',
  confirm_delete_team: 'Sind Sie sicher, dass Sie dieses Team löschen möchten?',
  overview: 'Übersicht',
  activity: 'Aktivität',
  wo_complete_last_14_days:
    'Arbeitsaufträge in den letzten 14 Tagen abgeschlossen',
  no_wo_complete_last_14_days:
    'Sie haben in den letzten zwei Wochen keine Arbeitsaufträge abgeschlossen',
  ADMIN_name: 'Administrator',
  ADMIN_description:
    'Administrator hat vollen Zugriff; einschließlich Bearbeiten, Hinzufügen, Löschen von Arbeitsaufträgen und Anfragen',
  LIMITED_ADMIN_name: 'Eingeschränkter Administrator',
  LIMITED_ADMIN_description:
    'Eingeschränkte Administratoren haben den gleichen Zugriff wie Administratoren, können jedoch keine Einstellungen anzeigen/bearbeiten oder Personen und Teams hinzufügen/bearbeiten. Sie können keine Arbeitsaufträge, Anlagenstandorte, Zähler und Bestellungen löschen, es sei denn, sie haben Auftragnehmer, Kategorien und PM-Trigger erstellt.',
  TECHNICIAN_name: 'Techniker',
  TECHNICIAN_description:
    'Techniker können Arbeitsaufträge, Anlagen und Standorte erstellen und schließen. Sie können nur das bearbeiten und löschen, was sie erstellt haben',
  LIMITED_TECHNICIAN_name: 'Eingeschränkter Techniker',
  LIMITED_TECHNICIAN_description:
    'Eingeschränkte Techniker können nur ihnen zugewiesene Arbeitsaufträge sehen',
  VIEW_ONLY_name: 'Nur Ansicht',
  VIEW_ONLY_description:
    'Nur Ansicht Benutzer haben vollen Zugriff auf die Ansicht, können jedoch nichts bearbeiten',
  REQUESTER_name: 'Anforderer',
  REQUESTER_description:
    'Anforderer können nur Arbeitsanforderungen einreichen und deren Status anzeigen',
  select_user_role: 'Benutzerrolle auswählen',
  'noRows.team.message':
    'Teams helfen Ihnen, spezifische Personengruppen zu verwalten.',
  'noRows.team.action': 'Drücken Sie die "+"-Taste, um ein Team zu erstellen.',
  user_details: 'Benutzerdetails',
  //files
  file_delete_success: 'Die Datei wurde erfolgreich gelöscht',
  file_delete_failure: 'Die Datei konnte nicht gelöscht werden',
  uploaded_by: 'Hochgeladen von',
  uploaded_on: 'Hochgeladen am',
  rename: 'Umbenennen',
  required_files: 'Bitte laden Sie mindestens eine Datei hoch',
  required_file_name: 'Bitte geben Sie einen Dateinamen ein',
  add_files: 'Dateien hinzufügen',
  edit_file: 'Datei bearbeiten',
  'noRows.file.message': 'Alle Dateien an einem Ort erhalten',
  'noRows.file.action': 'Drücken Sie die "+"-Taste, um eine Datei hochzuladen',
  upgrade_files:
    'Upgrade, um Dateien in Ihren Anlagen, Arbeitsaufträgen, Standorten usw. zu verwenden...',
  parts_consumption: 'Teileverbrauch',
  requests_analysis: 'Anfrageanalyse',
  //categories,
  category_create_success: 'Die Kategorie wurde erfolgreich erstellt',
  category_create_failure: 'Die Kategorie konnte nicht erstellt werden',
  category_edit_failure: 'Die Kategorie konnte nicht bearbeitet werden',
  category_delete_success: 'Die Kategorie wurde erfolgreich gelöscht',
  category_delete_failure: 'Die Kategorie konnte nicht gelöscht werden',
  timers: 'Timer',
  costs: 'Kosten',
  add_category: 'Neue Kategorie hinzufügen',
  add_category_description:
    'Geben Sie den Namen ein, um eine neue Kategorie zu erstellen und hinzuzufügen',
  edit_category: 'Kategorie bearbeiten',
  edit_category_description:
    'Geben Sie den Namen ein, um die Kategorie zu bearbeiten',
  no_category_action:
    'Drücken Sie die "+"-Taste, um Ihre erste Kategorie hinzuzufügen.',
  confirm_delete_category:
    'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?',
  no_category_message:
    'Es sieht so aus, als hätten Sie noch keine {{categoryName}}-Kategorien.',
  acquisition_cost: 'Erwerbskosten',
  //settings
  general_settings: 'Allgemeine Einstellungen',
  request_form_configuration: 'Anfrageformular-Konfiguration',
  roles: 'Rollen',
  checklists: 'Checklisten',
  field_configuration_description:
    'Sie können Felder als Optional, Versteckt oder Erforderlich markieren',
  optional: 'Optional',
  required: 'Erforderlich',
  hidden: 'Versteckt',
  creating_wo: 'Erstellen eines Arbeitsauftrags',
  completing_wo: 'Abschließen eines Arbeitsauftrags',
  role_edit_failure: 'Die Rolle konnte nicht bearbeitet werden',
  edit_role: 'Rolle bearbeiten',
  edit_role_description:
    'Füllen Sie die untenstehenden Felder aus, um die Rolle zu bearbeiten',
  external_id: 'Externe ID',
  permissions: 'Berechtigungen',
  create_role_description:
    'Diese Rolle kann alles tun, was ein Administrator in {{shortBrandName}} tun kann, aber Sie können einige wichtige Berechtigungen unten anpassen.',
  create_and_edit: 'Erstellen/Bearbeiten',
  to_access: 'Zugriff',
  role_delete_success: 'Die Rolle wurde erfolgreich gelöscht',
  role_delete_failure: 'Die Rolle konnte nicht gelöscht werden',
  confirm_delete_role:
    'Sind Sie sicher, dass Sie diese Rolle dauerhaft löschen möchten?',
  users: 'Benutzer',
  paid: 'Bezahlt',
  free: 'Kostenlos',
  role_create_success: 'Die Rolle wurde erfolgreich erstellt',
  role_create_failure: 'Die Rolle konnte nicht erstellt werden',
  roles_management: 'Rollenverwaltung',
  roles_number: '{{count}} Rollen',
  create_role: 'Rolle erstellen',
  upgrade_role: 'Upgrade, um eine Rolle zu erstellen',
  add_role: 'Neue Rolle hinzufügen',
  add_role_description:
    'Füllen Sie die untenstehenden Felder aus, um eine neue Rolle zu erstellen und hinzuzufügen',
  parts_and_sets: 'Teile & Teilesätze',
  upgrade_role_edit: 'Upgrade, um die Rolle zu bearbeiten',
  delete_role: 'Rolle löschen',
  upgrade_role_delete: 'Upgrade, um die Rolle zu löschen',
  create: 'Erstellen',
  pm_trigger: 'Präventive Wartungsauslösung',
  auto_assign_wo: 'Arbeitsaufträge automatisch zuweisen',
  auto_assign_wo_description:
    'Weisen Sie neue Arbeitsaufträge automatisch der Person zu, die sie erstellt',
  auto_assign_requests: 'Anfragen automatisch zuweisen',
  auto_assign_requests_description:
    'Weisen Sie neue Arbeitsaufträge automatisch der Person zu, die die Anfrage genehmigt',
  disable_closed_wo_notification:
    'Benachrichtigungen für geschlossene Arbeitsaufträge deaktivieren',
  disable_closed_wo_notification_description:
    'Benachrichtigungen deaktivieren, wenn geschlossene Arbeitsaufträge aktualisiert werden',
  ask_feedback_wo_closed:
    'Feedback anfordern, wenn der Arbeitsauftrag geschlossen wird',
  ask_feedback_wo_closed_description:
    'Benutzer werden gebeten, Feedback zur erledigten Arbeit zu geben',
  include_labor_in_total_cost: 'Arbeitskosten in die Gesamtkosten einbeziehen',
  include_labor_in_total_cost_description:
    'Arbeitskosten zu den Gesamtkosten hinzufügen, wenn ein Benutzer Zeit protokolliert und ein Stundensatz gespeichert ist',
  enable_wo_updates_requesters:
    'Arbeitsauftragsaktualisierungen für Anforderer aktivieren',
  enable_wo_updates_requesters_description:
    'Benutzer erhalten Aktualisierungen für die von ihnen angeforderten Arbeitsaufträge',
  language: 'Sprache',
  date_format: 'Datumsformat',
  business_type: 'Geschäftstyp',
  general_asset_management: 'Allgemeine Anlagenverwaltung',
  physical_asset_management: 'Physische Anlagenverwaltung',
  //checklist
  checklist_delete_success: 'Die Checkliste wurde erfolgreich gelöscht',
  checklist_delete_failure: 'Die Checkliste konnte nicht gelöscht werden',
  create_checklist: 'Checkliste erstellen',
  confirm_delete_checklist:
    'Sind Sie sicher, dass Sie diese Checkliste löschen möchten?',
  upgrade_checklist: 'Bitte upgraden, um Checklisten zu verwenden',
  //components
  upgrade_now: 'Jetzt upgraden',
  total: 'Gesamt',
  sub_task_status: 'Sub-Task-Status',
  text_field: 'Textfeld',
  number_field: 'Zahlenfeld',
  inspection_check: 'Inspektionsprüfung',
  multiple_choices: 'Mehrfachauswahl',
  meter_reading: 'Zählerstand',
  select_user: 'Benutzer auswählen',
  PASS: 'Bestanden',
  FLAG: 'Markieren',
  FAIL: 'Nicht bestanden',
  enter_task_name: 'Aufgabennamen eingeben',
  see_details: 'Details anzeigen',
  concerned_asset: 'Betroffene Anlage',
  me: 'Ich',
  remove_blank_tasks: 'Leere Aufgaben entfernen',
  remove_blank_options: 'Leere Optionen entfernen',
  preview: 'Vorschau',
  edit_checklist: 'Checkliste bearbeiten',
  add_tasks: 'Aufgaben hinzufügen',
  use_a_checklist: 'Eine Checkliste verwenden',
  select_checklist: 'Checkliste auswählen',
  save_checklist: 'Checkliste speichern',
  assign_tasks_description:
    'Benutzerdefinierte Aufgaben für Techniker zuweisen, um sie auszufüllen',
  select_date: 'Datum auswählen',
  task: 'Aufgabe',
  checklist: 'Checkliste',
  //analytics
  upgrade_analytics: 'Upgrade, um Analysen anzuzeigen',
  grouped_by_category: 'Nach Kategorie gruppiert',
  downtime_by_asset: 'Ausfallzeit nach Anlage',
  downtime_and_costs: 'Ausfallzeiten und Kosten',
  downtime_and_costs_trends: 'Trends bei Ausfallzeiten und Kosten',
  downtimes_trends: 'Trends bei Ausfallzeiten',
  repair_time_by_asset: 'Reparaturzeit nach Anlage',
  consumed_parts_costs: 'Kosten der verbrauchten Teile',
  requests_by_priority: 'Anfragen nach Priorität',
  requests_trends: 'Anfragetrends',
  time_spent: 'Verbrachte Zeit',
  grouped_by_completed_by: 'Nach Abgeschlossen von gruppiert',
  grouped_by_assigned_to: 'Nach Zugewiesen an gruppiert',
  grouped_by_priority: 'Nach Priorität gruppiert',
  completion_comparison: 'Abschlussvergleich',
  hours_worked: 'Geleistete Stunden',
  work_remaining: 'Verbleibende Arbeit',
  wo_status: 'Status des Arbeitsauftrags',
  cost_trends: 'Kostentrends',
  cost_center: 'Lebenszykluskostenanalyse der Anlage',
  downtime_and_availability: 'Ausfallzeiten und Verfügbarkeit',
  incomplete_wo: 'Unvollständige Arbeitsaufträge',
  the_numbers: 'Die Zahlen',
  hours_and_cost_by_asset: 'Stunden und Kosten nach Anlage',
  completion_comparison_description:
    'Vergleich verschiedener Arten von abgeschlossenen Arbeitsaufträgen.',
  wo_age_description:
    'Das Alter des Arbeitsauftrags ist definiert als die Anzahl der Tage zwischen der Erstellung des Arbeitsauftrags (oder der Arbeitsanforderung) und dem Abschluss.',
  rav_description:
    'Die Gesamtkosten als % des RAV entsprechen (Kosten der Arbeitsaufträge an der Anlage / Kaufpreis)*100. Der Industriestandard ist ein Zielwert von 3% für diese Kennzahl',
  downtime_and_availability_description:
    'Die Verfügbarkeit bezieht sich auf den Prozentsatz, in dem die Anlagen seit ihrem Inbetriebnahmedatum in einem betriebsbereiten Zustand waren. Die gesamten Ausfallzeiten beziehen sich auf die Anzahl der Ausfallereignisse, die während des angegebenen Datumsbereichs aufgetreten sind',
  total_cost_description:
    'Die Gesamtkosten umfassen Arbeitskosten, zusätzliche Kosten und Teilekosten in einem Arbeitsauftrag',
  compliant_wo_description:
    'Konforme Arbeitsaufträge sind definiert als Arbeitsaufträge, die vor dem Fälligkeitsdatum abgeschlossen wurden. Die Zykluszeit bezieht sich auf die Anzahl der Tage, bis ein Arbeitsauftrag abgeschlossen wurde.',
  hours_worked_description:
    'Diese Stunden entsprechen Arbeitsaufträgen, die ein Fälligkeitsdatum innerhalb des im Filter angegebenen Bereichs haben.',
  work_remaining_description:
    'Dieses Diagramm zeigt die Anzahl der unvollständigen Arbeitsaufträge, die im im Filter angegebenen Datumsbereich fällig sind. Die geschätzten Stunden entsprechen diesen einzelnen Arbeitsaufträgen.',
  total_downtime_in_hours: 'Gesamtausfallzeit (Stunden)',
  downtime_events: 'Ausfallereignisse',
  percent_downtime: '% Ausfallzeit',
  meantime_between_failures_in_hours:
    'Mittlere Zeit zwischen Ausfällen (Stunden)',
  availability_percent: 'Verfügbarkeitsprozentsatz',
  mean_time_to_repair_in_hours: 'Mittlere Reparaturzeit (Stunden)',
  average_age: 'Durchschnittsalter',
  count: 'Anzahl',
  average_cost: 'Durchschnittskosten',
  compliant: 'Konform',
  average_cycle_time_in_days: 'Durchschnittliche Zykluszeit (Tage)',
  total_consumption_cost: 'Gesamtkosten des Verbrauchs',
  parts_consumed: 'Verbrauchte Teile',
  total_cost_as_pct_rav: 'Gesamtkosten als Prozentsatz des RAV',
  approved_requests: 'Genehmigte Anfragen',
  pending_requests: 'Ausstehende Anfragen',
  cancelled_requests: 'Abgesagte Anfragen',
  average_cycle_time: 'Durchschnittliche Zykluszeit',
  compliance_rate: 'Konformitätsrate',
  complete: 'Komplett',
  reactive: 'Reaktiv',
  recurring: 'Wiederkehrend',
  part_costs: 'Teilekosten',
  labor_costs: 'Arbeitskosten',
  total_time_spent_in_hours: 'Gesamtzeitaufwand (Stunden)',
  estimated_hours: 'Geschätzte Stunden',
  total_purchase_price: 'Gesamtkaufpreis',
  you_have: 'Sie haben',
  new_messages: 'neue Nachrichten',
  //company profile
  company: 'Unternehmen',
  change_cover: 'Titelbild ändern',
  required_address: 'Das Adressfeld ist erforderlich',
  company_details: 'Unternehmensdetails',
  company_details_description:
    'Verwalten Sie Informationen zu Ihrem Unternehmen',
  learn_more: 'Mehr erfahren',
  //user profile
  profile: 'Profil',
  email_notifications: 'E-Mail-Benachrichtigungen',
  email_updates_wo: 'E-Mail-Updates für Arbeitsaufträge und Nachrichten',
  email_updates_requests: 'E-Mail-Updates für angeforderte Arbeitsaufträge',
  po_emails: 'E-Mails zu Bestellungen',
  required_job_title: 'Das Feld für die Berufsbezeichnung ist erforderlich',
  required_old_password: 'Bitte geben Sie das aktuelle Passwort ein.',
  invalid_password:
    'Passwort ist zu kurz - sollte mindestens 8 Zeichen lang sein.',
  required_new_password: 'Kein Passwort angegeben.',
  passwords_must_match: 'Passwörter müssen übereinstimmen',
  password_change_success: 'Passwort erfolgreich geändert',
  wrong_password: 'Falsches Passwort angegeben',
  current_password: 'Aktuelles Passwort',
  new_password: 'Neues Passwort',
  confirm_password: 'Passwort bestätigen',
  personal_details: 'Persönliche Details',
  personal_details_description:
    'Verwalten Sie Informationen zu Ihren persönlichen Details',
  change_password: 'Passwort ändern',
  notification_settings: 'Benachrichtigungseinstellungen',
  notification_settings_description:
    'Verwalten Sie Details zu Ihren Benachrichtigungen',
  recent_activity: 'Letzte Aktivität',
  created: 'Erstellt',
  completed: 'Abgeschlossen',
  my_account: 'Mein Konto',
  my_company: 'Mein Unternehmen',
  you_are_using_plan:
    'Sie verwenden derzeit den {{planName}}-Plan. Er läuft am {{expiration}} ab. Jetzt upgraden, um auf mehr Funktionen zuzugreifen.',
  upgrade_plan: 'Plan upgraden',
  //subscription
  plans: 'Pläne',
  monthly: 'Monatlich',
  annually: 'Jährlich',
  subscription_change_success: 'Das Abonnement wurde erfolgreich geändert',
  invalid_credit_card: 'Kreditkartennummer ist ungültig',
  required_credit_card: 'Das Kartenfeld ist erforderlich',
  invalid_expiration_month: 'Ablaufmonat ist ungültig',
  required_expiration_month: 'Der Ablaufmonat ist erforderlich',
  invalid_expiration_year: 'Ablaufjahr ist ungültig',
  required_expiration_year: 'Das Ablaufjahr ist erforderlich',
  invalid_cvv: 'CVV ist ungültig',
  required_cvv: 'Der CVV ist erforderlich',
  required_cardholder_name: 'Der Name des Karteninhabers ist erforderlich',
  card: 'Karte',
  expiration_month: 'Ablaufmonat',
  expiration_year: 'Ablaufjahr',
  cardholder_name: 'Name des Karteninhabers',
  seats: 'Sitze',
  cost_per_seat: 'Kosten pro Sitz',
  your_payment_secure: 'Ihre Zahlungsdaten sind verschlüsselt und sicher.',
  plan: 'Plan',
  current_plan: 'Aktueller Plan',
  number_users_who_will_use_grash:
    'Anzahl der Benutzer, die {{shortBrandName}} verwenden werden',
  admin_role: 'Admin',
  technical_role: 'Technisch',
  limited_technical_role: 'Begrenzter Techniker',
  requester_role: 'Anforderer',
  view_only_role: 'Nur Ansicht',
  how_will_you_be_billed: 'Wie möchten Sie abgerechnet werden?',
  which_plan_fits_you: 'Welcher Plan passt am besten zu Ihnen?',
  per_user_month: 'pro Benutzer/Monat',
  per_user_year: 'pro Benutzer/Jahr',
  you_will_be_charged: 'Ihnen wird berechnet',
  proceed_to_payment: 'Zur Zahlung fortfahren',
  pay_only_for_roles:
    'Zahlen Sie nur für <strong>Admin</strong>, <strong>Technisch</strong> und <strong>Begrenzter Techniker</strong>-Benutzer und nutzen Sie unbegrenzt <strong>Anforderer</strong>, <strong>Nur Ansicht</strong> kostenlos',
  checkout_our: 'Schauen Sie sich unsere',
  pricing_page: 'Preisseite',
  for_more_details: 'für weitere Details',
  users_count_display: '{{count}} Benutzer',
  monthly_adverb: 'monatlich',
  yearly_adverb: 'jährlich',
  features: 'Funktionen',
  checkout: 'Kasse',
  checkout_description: 'Füllen Sie die untenstehenden Felder aus',
  per_month: 'pro Monat',
  per_year: 'pro Jahr',
  recover_password_description:
    'Geben Sie die für die Registrierung verwendete E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
  send_me_new_password: 'Senden Sie mir ein neues Passwort',
  want_to_sign_in_again: 'Möchten Sie es erneut versuchen, sich anzumelden?',
  check_mails_for_instructions:
    'Überprüfen Sie Ihre E-Mails für weitere Anweisungen',
  pdf_report: 'PDF-Bericht',
  HIGH: 'Hoch',
  MEDIUM: 'Mittel',
  LOW: 'Niedrig',
  NONE: 'Keine',
  import: 'Importieren',
  start_import_process: 'Importprozess starten',
  import_data: 'Daten importieren',
  set_header: 'Kopfzeile festlegen',
  match_columns: 'Spalten zuordnen',
  review: 'Überprüfen',
  done: 'Erledigt',
  no_match_yet: 'Noch keine Übereinstimmung',
  select: 'Auswählen...',
  matched_to_field: 'Zugeordnet zu {{field}}',
  next: 'Weiter',
  not_enough_rows: 'Nicht genügend Zeilen in der Datei',
  there_are_duplicates: 'Es gibt Duplikate: {{duplicates}}',
  assigned_by: 'Zugewiesen von',
  percent_rows_have_value: '{{percent}}% der Zeilen haben einen Wert',
  match_at_least_column: 'Mindestens eine Spalte zuordnen',
  to_import: 'Importieren',
  required_match: '{{field}}-Zuordnung ist erforderlich',
  archived: 'Archiviert',
  import_wo_success:
    '{{created}} Arbeitsaufträge wurden erstellt und {{updated}} wurden aktualisiert',
  to_export: 'Exportieren',
  filters: 'Filter',
  more_filters: 'Weitere Filter',
  customer: 'Auftragnehmer',
  to: 'bis',
  dates: 'Daten',
  start: 'Start',
  end: 'Ende',
  longitude: 'Längengrad',
  latitude: 'Breitengrad',
  ALL: 'Alle',
  REACTIVE: 'Reaktiv',
  REPEATING: 'Präventiv',
  import_location_success:
    '{{created}} Standorte wurden erstellt und {{updated}} wurden aktualisiert',
  import_part_success:
    '{{created}} Teile wurden erstellt und {{updated}} wurden aktualisiert',
  import_meter_success:
    '{{created}} Zähler wurden erstellt und {{updated}} wurden aktualisiert',
  import_asset_success:
    '{{created}} Anlagen wurden erstellt und {{updated}} wurden aktualisiert',
  wo_calendar: 'Arbeitsauftragskalender',
  month: 'Monat',
  week: 'Woche',
  day: 'Tag',
  agenda: 'Agenda',
  previous: 'Vorherige',
  today: 'Heute',
  to_filter: 'Filtern',
  'noRows.asset.message':
    'Anlagen sind Ressourcen, an denen Ihr Unternehmen eingreifen kann',
  'noRows.asset.action':
    'Drücken Sie die "+"-Taste, um eine neue Anlage zu erstellen.',
  reset_filters: 'Filter zurücksetzen',
  toggle_menu: 'Menü umschalten',
  no_results: 'Keine Ergebnisse gefunden',
  an_error_occured: 'Ein Fehler ist aufgetreten.',
  density: 'Dichte',
  compact: 'Kompakt',
  standard: 'Standard',
  comfortable: 'Komfortabel',
  columns: 'Spalten',
  select_columns: 'Spalten auswählen',
  show_filters: 'Filter anzeigen',
  hide_filters: 'Filter ausblenden',
  search_placeholder: 'Suchen…',
  search: 'Suche',
  clear: 'Löschen',
  download_as_csv: 'Als CSV herunterladen',
  print: 'Drucken',
  download_as_excel: 'Als Excel herunterladen',
  find_column: 'Spalte finden',
  column_title: 'Spaltentitel',
  reorder_column: 'Spalte neu anordnen',
  show_all: 'Alle anzeigen',
  hide_all: 'Alle ausblenden',
  add_filter: 'Filter hinzufügen',
  logic_operator: 'Logikoperator',
  operator: 'Operator',
  and: 'Und',
  or: 'Oder',
  filter_value: 'Filterwert',
  contains: 'enthält',
  equals: 'gleich',
  starts_with: 'beginnt mit',
  ends_with: 'endet mit',
  is: 'ist',
  is_not: 'ist nicht',
  is_after: 'ist nach',
  is_on_or_after: 'ist an oder nach',
  is_before: 'ist vor',
  is_on_or_before: 'ist an oder vor',
  is_empty: 'ist leer',
  is_not_empty: 'ist nicht leer',
  is_any_of: 'ist eines von',
  any: 'beliebig',
  true_text: 'wahr',
  false_text: 'falsch',
  menu: 'Menü',
  show_columns: 'Spalten anzeigen',
  hide: 'Verstecken',
  unsort: 'Sortierung aufheben',
  sort_by_ASC: 'Aufsteigend sortieren',
  sort_by_DESC: 'Absteigend sortieren',
  sort: 'Sortieren',
  total_rows: 'Gesamtzeilen:',
  yes: 'Ja',
  no: 'Nein',
  more: 'Mehr',
  to_group: 'Gruppieren',
  see_children: 'Kinder sehen',
  hide_children: 'Kinder verstecken',
  expand: 'Erweitern',
  collapse: 'Zusammenbrechen',
  detail_panel_toggle: 'Detailbereich umschalten',
  cancel_subscription: 'Abonnement kündigen',
  resume_subscription: 'Abonnement fortsetzen',
  confirm_cancel_subscription:
    'Sind Sie sicher, dass Sie das Abonnement kündigen möchten?',
  workflows: 'Workflows',
  create_workflow: 'Workflow erstellen',
  if: 'Wenn',
  and_optional: 'Und (Optional)',
  then: 'Dann',
  workflow_description:
    'Erstellen Sie benutzerdefinierte Workflows so einfach wie Wenn, Und, Dann. Sparen Sie Zeit und weisen Sie Ihre Arbeitsaufträge automatisch durch Workflows zu, um {{shortBrandName}} an die Arbeitsweise Ihres Teams anzupassen.\\nAlle Pläne können bis zu 1 benutzerdefinierten Workflow erstellen. Um zusätzliche Workflows hinzuzufügen, upgraden Sie auf unseren Business-Plan',
  CREATE_PURCHASE_ORDER: 'Bestellung erstellen',
  PART_IS: 'Das Teil ist',
  QUANTITY_INFERIOR: 'Die Menge ist kleiner als',
  ASSIGN_VENDOR: 'Lieferant zuweisen',
  ASSIGN_CATEGORY: 'Kategorie zuweisen',
  APPROVE: 'Genehmigen',
  REJECT: 'Ablehnen',
  SEND_REMINDER_EMAIL: 'Erinnerungs-E-Mail senden',
  VENDOR_IS: 'Der Lieferant ist',
  CATEGORY_IS: 'Die Kategorie ist',
  STATUS_IS: 'Der Status ist',
  DUE_DATE_BETWEEN: 'Das Fälligkeitsdatum liegt zwischen',
  DUE_DATE_AFTER: 'Das Fälligkeitsdatum ist nach',
  ASSIGN_PRIORITY: 'Priorität zuweisen',
  ASSIGN_ASSET: 'Anlage zuweisen',
  ASSIGN_LOCATION: 'Standort zuweisen',
  ASSIGN_USER: 'Benutzer zuweisen',
  ASSIGN_TEAM: 'Team zuweisen',
  ADD_CHECKLIST: 'Checkliste hinzufügen',
  PRIORITY_IS: 'Die Priorität ist',
  ASSET_IS: 'Die Anlage ist',
  LOCATION_IS: 'Der Standort ist',
  USER_IS: 'Der Benutzer ist',
  TEAM_IS: 'Das Team ist',
  CREATED_AT_BETWEEN: 'Erstellt zwischen',
  TITLE_CONTAINS: 'Der Titel enthält',
  CREATE_REQUEST: 'Anfrage erstellen',
  CREATE_WORK_ORDER: 'Arbeitsauftrag erstellen',
  SET_ASSET_STATUS: 'Anlagenstatus festlegen',
  NAME_IS: 'Der Name ist',
  NAME_CONTAINS: 'Der Name enthält',
  VALUE_IS: 'Der Wert ist',
  VALUE_CONTAINS: 'Der Wert enthält',
  NUMBER_VALUE_SUPERIOR: 'Der Wert ist größer als',
  NUMBER_VALUE_INFERIOR: 'Der Wert ist kleiner als',
  WORK_ORDER_CREATED: 'Ein Arbeitsauftrag wird erstellt',
  WORK_ORDER_CLOSED: 'Ein Arbeitsauftrag wird geschlossen',
  WORK_ORDER_ARCHIVED: 'Ein Arbeitsauftrag wird archiviert',
  REQUEST_CREATED: 'Eine Anfrage wird erstellt',
  REQUEST_APPROVED: 'Eine Anfrage wird genehmigt',
  REQUEST_REJECTED: 'Eine Anfrage wird abgelehnt',
  PURCHASE_ORDER_CREATED: 'Eine Bestellung wird erstellt',
  PURCHASE_ORDER_UPDATED: 'Eine Bestellung wird aktualisiert',
  TASK_UPDATED: 'Eine Aufgabe wird aktualisiert',
  PART_UPDATED: 'Ein Teil wird aktualisiert',
  add_condition: 'Bedingung hinzufügen',
  workflow_creation_success: 'Workflow erfolgreich erstellt',
  workflow_creation_failure: 'Erstellung des Workflows nicht erfolgreich',
  action_value_missing: 'Der Aktionswert fehlt',
  condition_value_missing: 'Ein Bedingungswert fehlt',
  workflow_edit_success: 'Der Workflow wurde erfolgreich aktualisiert',
  workflow_edit_failure: 'Der Workflow konnte nicht bearbeitet werden',
  workflow_delete_success: 'Der Workflow wurde erfolgreich gelöscht',
  workflow_delete_failure: 'Der Workflow konnte nicht gelöscht werden',
  confirm_delete_workflow:
    'Sind Sie sicher, dass Sie diesen Workflow löschen möchten?',
  click_here: 'Klicken Sie hier',
  verify_email_title: 'E-Mail verifizieren',
  verify_email_description:
    'Eine Bestätigungs-E-Mail wurde an Sie gesendet. Überprüfen Sie den Spam-Ordner, wenn Sie sie nicht in Ihrem Posteingang finden.',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  upgrade_description:
    'Sie haben Ihr Abonnement gerade aktualisiert. Sie müssen die deaktivierten Benutzer aktivieren, die {{shortBrandName}} möglicherweise verwenden. Sie können dies nur einmal für das aktuelle Abonnement tun. Bitte wählen Sie sorgfältig aus',
  enable_users: 'Benutzer aktivieren',
  max_users_description: 'Sie können bis zu {{maxUsers}} Benutzer aktivieren',
  downgrade_description:
    'Sie haben Ihr Abonnement gerade herabgestuft. Sie müssen einige Benutzer deaktivieren, um fortzufahren. Sie können dies nur einmal für das aktuelle Abonnement tun. Bitte wählen Sie sorgfältig aus',
  disable_users: 'Benutzer deaktivieren',
  min_users_description:
    'Sie müssen mindestens {{minUsers}} Benutzer deaktivieren',
  downgrade_description_no_owner:
    'Ihr Unternehmen hat gerade sein Abonnement herabgestuft. Der Unternehmensinhaber muss einige Benutzer deaktivieren, bevor Sie fortfahren können',
  past_due: 'Überfällig',
  due_date_delay: 'Fälligkeitsdatum-Verzögerung',
  due_date_delay_description: 'Verzögerung des Fälligkeitsdatums in Tagen',
  days_count: '{{days}} Tage',
  trigger_configuration: 'Trigger-Konfiguration',
  WORK_ORDER_feature: 'Arbeitsaufträge',
  REQUEST_feature: 'Arbeitsanforderungen',
  PART_feature: 'Teileverwaltung',
  MOBILE_APP_feature: 'Mobile App',
  WORK_ORDER_HISTORY_feature: 'Arbeitsauftragsverlauf',
  PREVENTIVE_MAINTENANCE_feature: 'Präventive Wartung',
  CHECKLIST_feature: 'Checklisten',
  FILE_feature: 'Datei-Uploads',
  PURCHASE_ORDER_feature: 'Bestellungen',
  METER_feature: 'Zählerstände',
  REQUEST_CONFIGURATION_feature: 'Anfrageformular-Konfiguration',
  ADDITIONAL_TIME_feature: 'Erweiterte Zeiterfassung',
  ADDITIONAL_COST_feature: 'Erweiterte Kostenerfassung',
  ANALYTICS_feature: 'Analysen & Berichterstattung',
  REQUEST_PORTAL_feature: 'Anfrageportal',
  SIGNATURE_feature: 'Unterschriften',
  ROLE_feature: 'Benutzerdefinierte Rollen',
  WORKFLOW_feature: 'Workflow-Automatisierung',
  API_ACCESS_feature: 'API-Zugriff',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: 'Neue Option hinzufügen',
  edit_company: 'Unternehmen bearbeiten',
  fill_fields_below: 'Füllen Sie die untenstehenden Felder aus',
  IMPORT_CSV_feature: 'CSV-Import',
  no_import_access:
    'Upgraden Sie Ihren Plan, um aus CSV- und Excel-Dateien zu importieren',
  members: 'Mitglieder',
  assign_user: 'Benutzer zuweisen',
  assign_asset: 'Anlage zuweisen',
  required_files_on_completion:
    'Dateien sind bei Abschluss des Arbeitsauftrags erforderlich',
  required_tasks_on_completion: 'Aufgaben müssen abgeschlossen sein',
  required_labor_on_completion: 'Sie müssen Zeit protokollieren',
  required_part_on_completion:
    'Kein Teil wurde in diesem Arbeitsauftrag verwendet',
  required_cost_on_completion:
    'Keine Kosteninformationen in diesem Arbeitsauftrag angegeben',
  estimated_hours_in_text: '{{hours}} geschätzte Stunden',
  required_part_name: 'Teilename ist erforderlich',
  asset_update_failure: 'Die Anlage konnte nicht bearbeitet werden',
  terms_of_service: 'Nutzungsbedingungen',
  privacy_policy: 'Datenschutzrichtlinie',
  last_login: 'Letzte Anmeldung',
  not_enough_part: 'Es gibt nicht genug von diesem Teil',
  remove_blank_meter_tasks: 'Aufgaben mit Typ Zähler ohne Zähler entfernen',
  checklist_update_failure: 'Die Checkliste konnte nicht bearbeitet werden',
  contact_us: 'Kontaktieren Sie uns',
  simplify_wo: 'Arbeitsaufträge in der mobilen App vereinfachen',
  simplify_wo_description:
    'Verbergen Sie Zeitsteuerungen, Kosten und Teile in den Details des Arbeitsauftrags, während Sie die mobile App verwenden',
  account_deletion: 'Löschung des {{brandName}}-Kontos',
  switch_account: 'Konto wechseln',
  switch_to_super_user: 'Zu Super-Admin wechseln',
  switch_account_description: 'Bitte wählen Sie ein Konto, um fortzufahren',
  put_location_in_map: 'Standort in Karte einfügen',
  confirm_disable_user:
    'Sind Sie sicher, dass Sie {{user}} deaktivieren möchten? Sie können es erst nach einem Monat wieder aktivieren',
  user_disabled_success: 'Benutzer erfolgreich deaktiviert',
  disable: 'Deaktivieren',
  manufacturer: 'Hersteller',
  power: 'Leistung',
  import_error: 'Der Import war nicht erfolgreich',
  request_upgrade: 'Upgrade anfordern',
  operation_success: 'Der Vorgang war erfolgreich',
  CANCELLED: 'Abgelehnt',
  uptime_hours: 'Betriebszeit (h)',
  downtime_hours: 'Ausfallzeit (h)',
  mark_all_as_seen: 'Alle als gesehen markieren',
  estimation_accuracy_ratio: 'Genauigkeitsverhältnis der Schätzung',
  download_template: 'Vorlage herunterladen',
  pareto_by_total_price: 'Pareto nach Gesamtpreis',
  cumulative_percent: 'Kumulativer Prozentsatz',
  part_consumption_by_asset: 'Teilverbrauch nach Anlage',
  grouped_by_wo_category: 'Nach Arbeitsauftragskategorie gruppiert',
  resolution_rate: 'Lösungsrate',
  resolved: 'Gelöst',
  average: 'Durchschnitt',
  documentation: 'Dokumentation',
  days_before_pm_notification:
    'Vorab-Benachrichtigungen für geplante Arbeitsaufträge',
  estimated_start_date: 'Geschätztes Startdatum',
  no_file_linked_to_wo: 'Keine Datei mit diesem Arbeitsauftrag verknüpft',
  add_file: 'Datei hinzufügen',
  try_for_free: 'Kostenlos ausprobieren',
  choose_your_plan: 'Wählen Sie Ihren Plan',
  STARTER_description:
    'Teams, die effiziente und starke präventive Wartung durch Maschinenstatus und Sichtbarkeit der Arbeitskräfte aufbauen möchten.',
  PROFESSIONAL_description:
    'Abteilungen, die Einblicke und Analysen nutzen müssen, um weiteres Wachstum und Produktivität der Wartung zu fördern.',
  BUSINESS_description:
    'Organisationen, die bereit sind, Wartungs- und Betriebsdaten zu erfassen, um mehrere Standorte zu verwalten und das System anzupassen.',
  book_demo: 'Demo buchen',
  request_pricing: 'Preisanfrage für weitere Informationen',
  Reports: 'Berichte',
  'Custom dashboard built using the included components':
    'Benutzerdefiniertes Dashboard, erstellt mit den enthaltenen Komponenten',
  Export: 'Exportieren',
  'Last year': 'Letztes Jahr',
  Expenses: 'Ausgaben',
  Statistics: 'Statistiken',
  General: 'Allgemein',
  Calendar: 'Kalender',
  Mailbox: 'Postfach',
  Dashboards: 'Dashboards',
  Analytics: 'Analysen',
  Monitoring: 'Überwachung',
  Tasks: 'Aufgaben',
  Applications: 'Anwendungen',
  Users: 'Benutzer',
  'List All': 'Alle auflisten',
  'User Profile': 'Benutzerprofil',
  Login: 'Anmeldung',
  Register: 'Registrieren',
  'Recover Password': 'Passwort wiederherstellen',
  Status: 'Status',
  'Error 404': 'Fehler 404',
  'Error 500': 'Fehler 500',
  'Coming Soon': 'Demnächst',
  Maintenance: 'Wartung',
  Overview: 'Übersicht',
  Documentation: 'Dokumentation',
  Welcome: 'Willkommen',
  Help: 'Hilfe',
  'Features tour': 'Funktionstour',
  'Getting started guide': 'Einstiegsanleitung',
  'Contact support': 'Support kontaktieren',
  Version: 'Version',
  Search: 'Suche',
  Notifications: 'Benachrichtigungen',
  Settings: 'Einstellungen',
  'Language Switcher': 'Sprachumschalter',
  'Sign out': 'Abmelden',
  'Change Theme': 'Thema ändern',
  'View all notifications': 'Alle Benachrichtigungen anzeigen',
  rate: 'bewerten',
  select_at_least_column: 'Wählen Sie mindestens eine Spalte aus',
  already_read: 'Bereits gelesen',
  OPERATIONAL: 'Betriebsbereit',
  DOWN: 'Aus',
  MODERNIZATION: 'Modernisierung',
  STANDBY: 'Bereitschaft',
  INSPECTION_SCHEDULED: 'Inspektion geplant',
  COMMISSIONING: 'Inbetriebnahme',
  EMERGENCY_SHUTDOWN: 'Notabschaltung',
  select_asset_status: 'Anlagenstatus auswählen',
  asset_status: 'Anlagenstatus',
  ui_configuration: 'UI-Konfiguration',
  password_leave_empty_if_you_dont_want_to_change:
    'Passwort – leer lassen, wenn du es nicht ändern möchtest',
  upgrade_request_success:
    'Upgrade-Anfrage erhalten! Wir kontaktieren Sie in Kürze mit den Zahlungsdetails',
  continue_with_sso: 'Weiter mit SSO'
};

export default deJSON;
